import React from 'react';
import { observer } from 'mobx-react';
import {
  IconType, ButtonProps, Icon,
} from '@routific/hive';
import { useTranslation } from 'react-i18next';
import { useStore } from '../../../../store/mst';
import { RouteProps } from '../../../../store/mst/utils/getRoutesProps';
import ActionButton, { CommonActionTypes, ButtonTypes } from '../../../shared/ActionButton';

interface Props {
  routeProps: RouteProps;
  type?: ButtonTypes;
  buttonProps?: ButtonProps;
}

const DrawRouteButton: React.FC<Props> = ({
  routeProps, type, buttonProps,
}) => {
  const store = useStore();
  const { mapView } = store;

  const {
    isStarted, isDispatched, isLocked, isLoading, isReversing, disabled, noOrders,
  } = routeProps;

  const { t } = useTranslation(['common', 'components']);

  const handleClick = async () => {
    mapView.enterDrawMode();
    mapView.setSelectedItems();
  };

  const getTooltipText = () => {
    if (mapView.isLassoMode) {
      return t('components:moreActionsButton.route.button.draw.tooltip.lassoModeOn');
    }
    if (disabled || noOrders) {
      if (isStarted) {
        return t('components:moreActionsButton.route.button.draw.tooltip.isStarted');
      }
      if (isLocked || isLoading || isReversing) {
        return t('components:publish.tooltip.routeLocked');
      }
      if (noOrders) {
        return t('components:moreActionsButton.route.button.draw.tooltip.noOrders');
      }
      // CREATE_OPTIMIZATION still closes on published routes (fresh event uuids); check after more specific reasons.
      if (isDispatched) {
        return t('components:moreActionsButton.route.button.draw.tooltip.isDispatched');
      }
      return t('components:moreActionsButton.route.button.draw.tooltip.noPermission');
    }
    return undefined;
  };

  return (
    <>
      <ActionButton
        name={CommonActionTypes.DRAW_ROUTE}
        tooltipProps={{
          title: getTooltipText(),
        }}
        type={type}
        disabled={disabled || noOrders || mapView.isLassoMode}
        menuItemText={t('components:moreActionsButton.route.button.draw.text')}
        menuItemProps={{
          onClick: handleClick,
          icon: <Icon icon={IconType.MapDrawRoute} />,
        }}
        buttonProps={{
          icon: IconType.MapDraw,
          style: { pointerEvents: isStarted ? 'none' : 'auto' },
          onClick: handleClick,
          ...buttonProps,
        }}
      />
    </>
  );
};

export default observer(DrawRouteButton);
